import { render, staticRenderFns } from "./VehicleFilter.vue?vue&type=template&id=2785bc0e&"
import script from "./VehicleFilter.vue?vue&type=script&lang=js&"
export * from "./VehicleFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports